<template>
  <div>
    <div v-for="(item, idx) in feeform" :key="idx"> 
      <FeeForm :key="'fee'+idx" :ref="'fee'+idx" :control="item"  :total="total" :cl="clientlist" :type="title" :jl="jl" v-bind="$attrs"
      @add="handleadd" @del="handledel" @entry1="handleEntry1Change" @entry2="handleEntry2Change"/>
    </div>
  </div>
</template>
<script>
import FeeForm from "@/components/Settings/FeeForm.vue"

export default {
  props: {
    title : {
      type: String,
    },
    fixMethod : {
      type: Boolean,
      default: false,
    },
    addable : {
      type: Boolean,
      default : false,
    },
    cl : {},
    jl : {
      type: Array,
      default: [],
    },
    cardInfo : {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      clientlist : this.cl,
      total : 1,
      cardctr : {
          addable: (this.title == 'creditCard') ? false : 
            (this.title == 'gmo') ? true : 
            (this.title == 'creditCard3000') ? true : false,
          fixMethod: this.fixMethod,
      },
      feeform: [
        { 
          count: 0,
          addable: (this.title == 'creditCard') ? false : 
            (this.title == 'gmo') ? true : 
            (this.title == 'creditCard3000') ? true : false,
          fixMethod: this.fixMethod,
          amount: this.cardInfo.length>0 ? this.cardInfo[0].amount : 0,
          unit: this.cardInfo.length>0 ? this.cardInfo[0].unit: 'percent',
          method: this.cardInfo.length>0 ? this.cardInfo[0].method:  'single',
          taxRate: this.cardInfo.length>0 ? this.cardInfo[0].taxRate: 0.1,
          client: this.cardInfo.length>0 ? this.cardInfo[0].client: '',
          code: this.cardInfo.length>0 ? this.cardInfo[0].code : '', 
          type: this.title,
          bookEntry: this.cardInfo.length>0 ? this.cardInfo[0].bookEntry : '',
          entry1 : this.cardInfo.length>0 ? this.cardInfo[0].entry1 : '',
          entry2 : this.cardInfo.length>0 ? this.cardInfo[0].entry2 : '',
        }
      ],
    }
  },
  
  components: {
    FeeForm,
  },

  mounted() {
    if(this.cardInfo.length > 0) {
      this.feeform = []
      this.cardInfo.map((item,i) => {
        this.feeform.push({
          ...this.cardctr,
          ...item,
          count: i,
        })
      })
      this.total = this.cardInfo.length
    }
  },

  methods: {
    handleadd() {
      // add a component
      let item = {
        count : this.feeform[this.feeform.length -1].count + 1,
        addable: this.feeform[this.feeform.length-1].addable,
        fixMethod: this.feeform[this.feeform.length-1].fixMethod,
        amount: 0,
        unit: 'percent',
        method: 'single',
        taxRate: 0.1,
        client: '',
        code: '', 
     }
      this.total++
      this.feeform.push(item)
      this.$emit('setChange', this.total, 0)
    },
    handledel(idx) {
      // add a component
      this.feeform.splice(idx, 1)
      this.total-- 
      let curval = 0
      this.feeform.forEach(item => {
        item.count = curval
        curval++
      })
      this.$emit('setChange', this.total, idx)
    },
    handleEntry1Change(idx, val) {
      this.$emit('entry1', idx, val)
    },
    handleEntry2Change(idx, val) {
      this.$emit('entry2', idx, val)
    },
    returnData() {
      let cardFees = []
      let that = this
      this.feeform.map((item,i) => {
        cardFees.push(that.$refs["fee"+i][0].getData())
      })
      return cardFees
    },
    returnFeeSets() {
      return total
    }
  },

//   computed: {
//     isDisableDate() {
//       return !this.reflect;
//     },
//   },
//   watch: {
//     reflect(val) {
//       this.validDay = val ? this.today + 86400000 : this.today;
//     },
//     date(val) {
//       this.reflect = val > this.today;
//     },
//   },
};
</script>